/**
 *  @class
 *  @function FeaturedCollectionList
 */

if (!customElements.get('featured-collection-list')) {
  class FeaturedCollectionList extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.featured-collection-list--button'));

      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.setupAnimations();
      }

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const button = e.target.closest('.featured-collection-list--button');
          if (button) {
            this.buttons.forEach((b) => b.classList.remove('active'));
            button.classList.add('active');
          }
        });
        this.addEventListener('shopify:section:load', () => {
          setTimeout(() => {
            if (typeof ScrollTrigger !== 'undefined') {
              ScrollTrigger.refresh();
            }
          }, 100);
        });
      }
    }
    setupAnimations() {
      ScrollTrigger.batch(this.querySelectorAll('.featured-collection-list--span span'), {
        onEnter: (elements) => {
          gsap.to(elements, { y: 0, stagger: 0.1, ease: window.theme.settings.animation_easing });
        },
      });
    }
  }
  customElements.define('featured-collection-list', FeaturedCollectionList);
}
